import React from 'react';
import { Navigate } from 'react-router-dom';
import { withPageTransition } from '../utils/withTransition';

// This is a wrapper component that will be used for the /dashboard route
// It ensures proper state management and navigation when directly accessing the dashboard URL
const DashboardPage: React.FC<any> = () => {

  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem('mocktrail-token') !== null;
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  // Redirect to the root route which handles the dashboard rendering with proper state
  return <Navigate to="/" replace />;
};

DashboardPage.displayName = 'DashboardPage';

export default withPageTransition(DashboardPage); 